/* eslint-disable @next/next/no-img-element */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faPhone } from "@fortawesome/pro-solid-svg-icons";
import { ComponentInfosLojaSchedulesInput } from "@/graphql/generated/graphql";
import styles from "./styles.module.scss";
import WhatsAppIcon from "public/img/icon/whatsapp.svg";
import { formattedTime } from "@/utils/helpers";

export type SchedulesProps = {
  schedules: ComponentInfosLojaSchedulesInput;
  phone: string;
  whatsapp?: string;
};

const Schedules = ({ schedules, phone, whatsapp }: SchedulesProps) => (
  <div className={styles.wrapper}>
    <FontAwesomeIcon icon={faClock} fontSize={24} />
    <div className={`${styles.content} body-text-md`}>
      <p>
        <span>Segunda à Sexta</span>
        <span>
          {formattedTime(schedules.semanaAbertura)} às{" "}
          {formattedTime(schedules.semanaFechamento)}
        </span>
      </p>
      <p>
        <span>Sábado</span>
        <span>
          {formattedTime(schedules.sabadoAbertura)} às{" "}
          {formattedTime(schedules.sabadoFechamento)}
        </span>
      </p>
      <p>
        <span>Domingo</span>
        <span>
          {formattedTime(schedules.domingoAbertura)} às{" "}
          {formattedTime(schedules.domingoFechamento)}
        </span>
      </p>
      <p>
        <span>Feriados</span>
        <span>
          {formattedTime(schedules.feriadoAbertura)} às{" "}
          {formattedTime(schedules.feriadoFechamento)}
        </span>
      </p>
    </div>
    {phone && (
      <>
        <a href={`tel:${phone}`}>
          <FontAwesomeIcon icon={faPhone} fontSize={24} />
        </a>
        <a href={`tel:${phone}`}>{phone}</a>
      </>
    )}

    {!!whatsapp && (
      <a href={whatsapp} target="_blank" className={`btn ${styles.btn}`}>
        <img src={WhatsAppIcon.src} alt="Ícone do WhatsApp" width={20} />
        Comprar pelo Whatsapp
      </a>
    )}
  </div>
);

export default Schedules;
